'use strict';

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        responsiveState: 1,
        dashboardEnlargedItem: null,
        pageNumber: 1,
        scrollbarWidth: 15,
        enterpriseId: null,
        enterpriseName: null,
        enterpriseStatus: null,
        selectedPartner: null,
        setPartnerRiskWidgetSelectedPartnerId: null,
        comodoUserLogo: null,
        comodoUserObject: null,
        isActiveUser: null,
        comodoAdminRole: null,
        comodoAdminName: null,
        managerSession: null,
        userFirstName: null,
        userLastName: null,
        userPhoneNumber: null,
        isPrimaryUser: null,
        apiKey: null,
        permissions: null,
        selectedPartnerRiskScoreItem: null,
        selectedRiskScoreItem: null,
        selectedHourZeroPreventionTimelineItem: null,
        selectedAttackometerVendor: null,
        // selectedMalwareTimerVendor: null,
        realtimeMalwareDetectionIndex: 5,
        malwareSoftwareEfficiencyIndex: 4,
        // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
        // malwareThreatForecastIndex: 10,
        targetedPhishingIndex: 6,
        // INFO: this component is commented out because if it is intended to be displayed again.
        // attackometerIndex: 7,
        // malwareTimerIndex: 6,
        riskScoreIndex: 1,
        partnerRiskScoreIndex: -1,
        // INFO: this component is commented out because if it is intended to be displayed again.
        // hourZeroPreventionTimelineIndex: 4,
        threatTimeLineIndex: 3,
        application_version: null,
        notificationExtendable: null,
        resourceURL: null,
        zoomLevelIndex: 2,
        maximizeZoomLevelIndex: 2,
        iframeUrl: null,
        iframeSelection: null,
        isComingFromSearchBar: null,
        isIframeVisible: null,
        platformKillChainEndPoint: null,
        whiteLabelingData: null,
        isPhoneModalDisplayed: null,
        page: null
    },
    getters: {
        getThreatTimeLineIndex(state) {
            return state.threatTimeLineIndex;
        },
        getRealtimeMalwareDetectionIndex(state) {
            return state.realtimeMalwareDetectionIndex;
        },
        getResourceURL(state) {
            return state.resourceURL;
        },
        getMalwareSoftwareEfficiencyIndex(state) {
            return state.malwareSoftwareEfficiencyIndex;
        },
        // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
        // getMalwareThreatForecastIndex(state) {
        //     return state.malwareThreatForecastIndex;
        // },
        getTargetedPhishingIndex(state) {
            return state.targetedPhishingIndex;
        },
        getAttackometerIndex(state) {
            return state.attackometerIndex;
        },
        // getMalwareTimerIndex(state) {
        //     return state.malwareTimerIndex;
        // },
        getRiskScoreIndex(state) {
            return state.riskScoreIndex;
        },
        getResponsiveState(state) {
            return state.responsiveState;
        },
        getDashboardEnlargedItem(state) {
            return state.dashboardEnlargedItem;
        },
        getPageNumber(state) {
            return state.pageNumber;
        },
        getScrollbarWidth(state) {
            return state.scrollbarWidth;
        },
        getEnterpriseId(state) {
            return state.enterpriseId;
        },
        getEnterpriseName(state) {
            return state.enterpriseName;
        },
        getEnterpriseStatus(state) {
            return state.enterpriseStatus;
        },
        getSelectedPartner(state) {
            return state.selectedPartner;
        },
        getPartnerRiskWidgetSelectedPartnerId(state) {
            return state.partnerRiskWidgetSelectedPartnerId;
        },
        getComodoUserLogo(state) {
            return state.comodoUserLogo;
        },
        getComodoUserObject(state) {
            return state.comodoUserObject;
        },
        getIsActiveUser(state) {
            return state.isActiveUser;
        },
        getComodoAdminRole(state) {
            return state.comodoAdminRole;
        },
        getComodoAdminName(state) {
            return state.comodoAdminName;
        },
        getManagerSession(state) {
            return state.managerSession;
        },
        getUserFirstName(state) {
            return state.userFirstName;
        },
        getUserLastName(state) {
            return state.userLastName;
        },
        getUserPhoneNumber(state) {
            return state.userPhoneNumber;
        },
        getIsPrimaryUser(state) {
            return state.isPrimaryUser;
        },
        getApiKey(state) {
            return state.apiKey;
        },
        getUserPermissions(state) {
            return state.permissions;
        },
        getSelectedPage(state) {
            return state.page;
        },
        getSelectedRiskScoreItem(state) {
            return state.selectedRiskScoreItem;
        },
        getSelectedPartnerRiskScoreItem(state) {
            return state.selectedPartnerRiskScoreItem;
        },
        // getSelectedAttackometerVendor(state) {
        //     return state.selectedAttackometerVendor;
        // },
        // getSelectedMalwareTimerVendor(state) {
        //     return state.selectedMalwareTimerVendor;
        // },
        getApplicationVersion(state) {
            return state.application_version;
        },
        getNotificationExtendable(state) {
            return state.notificationExtendable;
        },
        getPartnerRiskScoreIndex(state) {
            return state.partnerRiskScoreIndex;
        },
        // INFO: this component is commented out because if it is intended to be displayed again.
        // getHourZeroPreventionTimelineIndex(state) {
        //     return state.hourZeroPreventionTimelineIndex;
        // },
        getSelectedHourZeroPreventionTimelineItem(state) {
            return state.selectedHourZeroPreventionTimelineItem;
        },
        getZoomLevelIndex(state) {
            return state.zoomLevelIndex;
        },
        getMaximizeZoomLevelIndex(state) {
            return state.maximizeZoomLevelIndex;
        },
        getIframeUrl(state) {
            return state.iframeUrl;
        },
        getIsComingFromSearchBar(state) {
            return state.isComingFromSearchBar;
        },
        getIframeSelection(state) {
            return state.iframeSelection;
        },
        getIsIframeVisible(state){
            return state.isIframeVisible;
        },
        getPlatformKillChainEndPoint(state) {
            return state.platformKillChainEndPoint;
        },
        getWhiteLabelingData(state) {
            return state.whiteLabelingData;
        },
        getIsPhoneModalDisplayed(state) {
            return state.isPhoneModalDisplayed;
        }
    },
    mutations: {
        setThreatTimeLineIndex(state, threatTimeLineIndex) {
            state.threatTimeLineIndex = threatTimeLineIndex;
        },
        setRealtimeMalwareDetectionIndex(state, realtimeMalwareDetectionIndex) {
            state.realtimeMalwareDetectionIndex = realtimeMalwareDetectionIndex;
        },
        setResourceURL(state, resourceURL) {
            state.resourceURL = resourceURL;
        },
        setMalwareSoftwareEfficiencyIndex(state, malwareSoftwareEfficiencyIndex) {
            state.malwareSoftwareEfficiencyIndex = malwareSoftwareEfficiencyIndex;
        },
        // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
        // setMalwareThreatForecastIndex(state, malwareThreatForecastIndex) {
        //     state.malwareThreatForecastIndex = malwareThreatForecastIndex;
        // },
        setTargetedPhishingIndex(state, targetedPhishingIndex) {
            state.targetedPhishingIndex = targetedPhishingIndex;
        },
        // INFO: this component is commented out because if it is intended to be displayed again.
        // setAttackometerIndex(state, attackometerIndex) {
        //     state.attackometerIndex = attackometerIndex;
        // },
        // setMalwareTimerIndex(state, malwareTimerIndex) {
        //     state.malwareTimerIndex = malwareTimerIndex;
        // },
        setRiskScoreIndex(state, riskScoreIndex) {
            state.riskScoreIndex = riskScoreIndex;
        },
        setResponsiveState(state, responsiveState) {
            state.responsiveState = responsiveState;
        },
        setDashboardEnlargedItem(state, itemNumber) {
            if (state.dashboardEnlargedItem == itemNumber)
                state.dashboardEnlargedItem = null;
            else
                state.dashboardEnlargedItem = itemNumber;
        },
        setSelectedPageNumber(state, pageNumber) {
            state.pageNumber = pageNumber;
        },
        setScrollbarWidth(state, scrollbarWidth) {
            state.scrollbarWidth = scrollbarWidth;
        },
        setEnterpriseId(state, enterpriseId) {
            state.enterpriseId = enterpriseId;
        },
        setEnterpriseName(state, enterpriseName) {
            state.enterpriseName = enterpriseName;
        },
        setEnterpriseStatus(state, enterpriseStatus) {
            state.enterpriseStatus = enterpriseStatus;
        },
        setSelectedPartner(state, selectedPartner) {
            state.selectedPartner = selectedPartner;
        },
        setComodoUserLogo(state, comodoUserLogo) {
            state.comodoUserLogo = comodoUserLogo;
        },
        setComodoUserObject(state, comodoUserObject) {
            state.comodoUserObject = comodoUserObject;
        },
        setIsActiveUser(state, isActiveUser) {
            state.isActiveUser = isActiveUser;
        },
        setComodoAdminRole(state, comodoAdminRole) {
            state.comodoAdminRole = comodoAdminRole;
        },
        setComodoAdminName(state, comodoAdminName) {
            state.comodoAdminName = comodoAdminName;
        },
        setManagerSession(state, managerSession) {
            state.managerSession = managerSession;
        },
        setUserFirstName(state, userFirstName) {
            state.userFirstName = userFirstName;
        },
        setUserLastName(state, userLastName) {
            state.userLastName = userLastName;
        },
        setUserPhoneNumber(state, phoneNumber) {
            state.userPhoneNumber = phoneNumber;
        },
        setIsPrimaryUser(state, isPrimaryUser) {
            state.isPrimaryUser = isPrimaryUser;
        },
        setApiKey(state, apiKey) {
            state.apiKey = apiKey;
        },
        setUserPermissions(state, permissions) {
            state.permissions = permissions;
        },
        setSelectedPage(state, page) {
            state.page = page;
        },
        setSelectedRiskScoreItem(state, item) {
            state.selectedRiskScoreItem = item;
        },
        setSelectedPartnerRiskScoreItem(state, item) {
            state.selectedPartnerRiskScoreItem = item;
        },
        setPartnerRiskWidgetSelectedPartnerId(state, item) {
            state.partnerRiskWidgetSelectedPartnerId = item;
        },
        // INFO: this component is commented out because if it is intended to be displayed again.
        // setSelectedAttackometerVendor(state, vendor) {
        //     state.selectedAttackometerVendor = vendor;
        // },
        // setSelectedMalwareTimerVendor(state, vendor) {
        //     state.selectedMalwareTimerVendor = vendor;
        // },
        setApplicationVersion(state, application_version) {
            state.application_version = application_version;
        },
        setNotificationExtendable(state, notificationExtendable) {
            state.notificationExtendable = notificationExtendable;
        },
        setPartnerRiskScoreIndex(state, partnerRiskScoreIndex) {
            state.partnerRiskScoreIndex = partnerRiskScoreIndex;
        },
        // INFO: this component is commented out because if it is intended to be displayed again.
        // setHourZeroPreventionTimelineIndex(state, hourZeroPreventionTimelineIndex) {
        //     state.hourZeroPreventionTimelineIndex = hourZeroPreventionTimelineIndex;
        // },
        setSelectedHourZeroPreventionTimelineItem(state, item){
            state.selectedHourZeroPreventionTimelineItem = item;
        },
        setZoomLevelIndex(state, zoomLevelIndex) {
            state.zoomLevelIndex = zoomLevelIndex;
        },
        setMaximizeZoomLevelIndex(state, maximizeZoomLevelIndex) {
            state.maximizeZoomLevelIndex = maximizeZoomLevelIndex;
        },
        setIframeUrl(state, URL) {
            state.iframeUrl = URL;
        },
        setIsIframeVisible(state, visibility){
            state.isIframeVisible = visibility;
        },
        setIsComingFromSearchBar(state, isComingFromSearchBar){
            state.isComingFromSearchBar = isComingFromSearchBar;
        },
        setIframeSelection(state, selection) {
            state.iframeSelection = selection;
        },
        setPlatformKillChainEndPoint(state, platformKillChainEndPoint) {
            state.platformKillChainEndPoint = platformKillChainEndPoint;
        },
        setWhiteLabelingData(state, whiteLabelingData) {
            state.whiteLabelingData = whiteLabelingData;
        },
        setIsPhoneModalDisplayed(state, displayed){
            state.isPhoneModalDisplayed = displayed;
        }
    },
    actions: {
        setThreatTimeLineIndex(context, threatTimeLineIndex) {
            context.commit("setThreatTimeLineIndex", threatTimeLineIndex);
        },
        setRealtimeMalwareDetectionIndex(context, realtimeMalwareDetectionIndex) {
            context.commit("setRealtimeMalwareDetectionIndex", realtimeMalwareDetectionIndex);
        },
        setResourceURL(context, resourceURL) {
            context.commit("setResourceURL", resourceURL);
        },
        setMalwareSoftwareEfficiencyIndex(context, malwareSoftwareEfficiencyIndex) {
            context.commit("setMalwareSoftwareEfficiencyIndex", malwareSoftwareEfficiencyIndex);
        },
        // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
        // setMalwareThreatForecastIndex(context, malwareThreatForecastIndex) {
        //     context.commit("setMalwareThreatForecastIndex", malwareThreatForecastIndex);
        // },
        setTargetedPhishingIndex(context, targetedPhishingIndex) {
            context.commit("setTargetedPhishingIndex", targetedPhishingIndex);
        },
        // INFO: this component is commented out because if it is intended to be displayed again.
        // setAttackometerIndex(context, attackometerIndex) {
        //     context.commit("setAttackometerIndex", attackometerIndex);
        // },
        // setMalwareTimerIndex(context, malwareTimerIndex) {
        //     context.commit("setMalwareTimerIndex", malwareTimerIndex);
        // },
        setRiskScoreIndex(context, riskScoreIndex) {
            context.commit("setRiskScoreIndex", riskScoreIndex);
        },
        setResponsiveState(context, responsiveState) {
            context.commit("setResponsiveState", responsiveState);
        },
        setDashboardEnlargedItem(context, itemNumber) {
            context.commit("setDashboardEnlargedItem", itemNumber);
        },
        setSelectedPageNumber(context, pageNumber) {
            context.commit("setSelectedPageNumber", pageNumber);
        },
        setScrollbarWidth(context, scrollbarWidth) {
            context.commit("setScrollbarWidth", scrollbarWidth);
        },
        setEnterpriseId(context, enterpriseId) {
            context.commit("setEnterpriseId", enterpriseId);
        },
        setEnterpriseName(context, enterpriseName) {
            context.commit("setEnterpriseName", enterpriseName);
        },
        setEnterpriseStatus(context, enterpriseStatus) {
            context.commit("setEnterpriseStatus", enterpriseStatus);
        },
        setSelectedPartner(context, selectedPartner) {
            context.commit("setSelectedPartner", selectedPartner);
        },
        setComodoUserLogo(context, comodoUserLogo) {
            context.commit("setComodoUserLogo", comodoUserLogo);
        },
        setComodoUserObject(context, comodoUserObject) {
            context.commit("setComodoUserObject", comodoUserObject);
        },
        setIsActiveUser(context, isActiveUser) {
            context.commit("setIsActiveUser", isActiveUser);
        },
        setComodoAdminRole(context, comodoAdminRole) {
            context.commit("setComodoAdminRole", comodoAdminRole);
        },
        setComodoAdminName(context, comodoAdminName) {
            context.commit("setComodoAdminName", comodoAdminName);
        },
        setManagerSession(context, managerSession) {
            context.commit("setManagerSession", managerSession);
        },
        setUserFirstName(context, userFirstName) {
            context.commit("setUserFirstName", userFirstName);
        },
        setUserLastName(context, userLastName) {
            context.commit("setUserLastName", userLastName);
        },
        setUserPhoneNumber(context, userPhoneNumber) {
            context.commit("setUserPhoneNumber", userPhoneNumber);
        },
        setIsPrimaryUser(context, isPrimaryUser) {
            context.commit("setIsPrimaryUser", isPrimaryUser);
        },
        setApiKey(context, apiKey) {
            context.commit("setApiKey", apiKey);
        },
        setUserPermissions(context, permissions) {
            context.commit("setUserPermissions", permissions);
        },
        setSelectedPage(context, page) {
            context.commit("setSelectedPage", page);
        },
        setSelectedRiskScoreItem(context, item) {
            context.commit("setSelectedRiskScoreItem", item);
        },
        setSelectedPartnerRiskScoreItem(context, item) {
            context.commit("setSelectedPartnerRiskScoreItem", item);
        },
        // INFO: this component is commented out because if it is intended to be displayed again.
        // setSelectedAttackometerVendor(context, vendor) {
        //     context.commit("setSelectedAttackometerVendor", vendor);
        // },
        // setSelectedMalwareTimerVendor(context, vendor) {
        //     context.commit("setSelectedMalwareTimerVendor", vendor);
        // },
        setApplicationVersion(context, application_version) {
            context.commit("setApplicationVersion", application_version);
        },
        setNotificationExtendable(context, notificationExtendable) {
            context.commit("setNotificationExtendable", notificationExtendable);
        },
        setPartnerRiskScoreIndex(context, partnerRiskScoreIndex) {
            context.commit("setPartnerRiskScoreIndex", partnerRiskScoreIndex);
        },
        setPartnerRiskWidgetSelectedPartnerId(context, item) {
            context.commit("setPartnerRiskWidgetSelectedPartnerId", item)
        },
        // INFO: this component is commented out because if it is intended to be displayed again.
        // setHourZeroPreventionTimelineIndex(context, hourZeroPreventionTimelineIndex) {
        //     context.commit("setHourZeroPreventionTimelineIndex", hourZeroPreventionTimelineIndex)
        // },
        setSelectedHourZeroPreventionTimelineItem(context, item) {
            context.commit("setSelectedHourZeroPreventionTimelineItem", item)
        },
        setZoomLevelIndex(context, zoomLevelIndex) {
            context.commit("setZoomLevelIndex", zoomLevelIndex);
        },
        setMaximizeZoomLevelIndex(context, maximizeZoomLevelIndex) {
            context.commit("setMaximizeZoomLevelIndex", maximizeZoomLevelIndex);
        },
        setIframeUrl(context, URL) {
            context.commit("setIframeUrl", URL);
        },
        setIsComingFromSearchBar(context, isComingFromSearchBar) {
            context.commit("setIsComingFromSearchBar", isComingFromSearchBar)
        },
        setIframeSelection(context, selection) {
            context.commit("setIframeSelection", selection)
        },
        setIsIframeVisible(context, visibility){
            context.commit("setIsIframeVisible", visibility)
        },
        setPlatformKillChainEndPoint(context, platformKillChainEndPoint) {
            context.commit("setPlatformKillChainEndPoint", platformKillChainEndPoint);
        },
        setWhiteLabelingData(context, whiteLabelingData) {
            context.commit("setWhiteLabelingData", whiteLabelingData);
        },
        setIsPhoneModalDisplayed(context, displayed){
            context.commit("setIsPhoneModalDisplayed", displayed);
        }
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js